import { Box, Skeleton } from '@mui/material';
import { colors } from '@src/styles';
import { skeletonSX } from '../utils/format';

const NAME_WIDTHS = ['62%', '48%', '70%', '55%', '66%', '52%'];

export function LogsTableSkeleton({ rows = 6 }: { rows?: number }) {
  return (
    <Box aria-hidden>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'minmax(0, 2fr) 110px 150px 150px',
          gap: 2,
          paddingY: 1.25,
          borderBottom: `1px solid ${colors.brand.line}`,
        }}
      >
        {[70, 50, 44, 30].map((width) => (
          <Skeleton key={width} variant="text" width={width} height={14} sx={skeletonSX} />
        ))}
      </Box>
      {Array.from({ length: rows }, (_, index) => (
        <Box
          key={index}
          sx={{
            display: 'grid',
            gridTemplateColumns: 'minmax(0, 2fr) 110px 150px 150px',
            alignItems: 'center',
            gap: 2,
            paddingY: 1.25,
            borderBottom: `1px solid ${colors.brand.line}`,
          }}
        >
          <Skeleton variant="text" width={NAME_WIDTHS[index % NAME_WIDTHS.length]} height={18} sx={skeletonSX} />
          <Skeleton variant="rounded" width={82} height={22} sx={{ ...skeletonSX, borderRadius: '999px' }} />
          <Skeleton variant="text" width={130} height={16} sx={skeletonSX} />
          <Skeleton variant="text" width={130} height={16} sx={skeletonSX} />
        </Box>
      ))}
    </Box>
  );
}
